import React from 'react';
export function CropIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M6 0H4v4H0v2h4v12a2 2 0 002 2h10v-2H6V0z"
  }), React.createElement("path", {
    d: "M18 4H8v2h10v18h2v-4h4v-2h-4V6a2 2 0 00-2-2z"
  }));
}